
export class KeyboardUtil {
    private static instance: KeyboardUtil;

    static getInstance() {
        if (!KeyboardUtil.instance) {
            KeyboardUtil.instance = new KeyboardUtil();
        }

        return KeyboardUtil.instance;
    }

    popupsOpenedCount: number;
    /**
    * KeyboardUtil is a singleton class, so use KeyboardUtil.getInstance() method instead of creating new KeyboardUtil().
    */
    private constructor() {
        this.popupsOpenedCount = 0;
    }

    isModifierKey(key: string): boolean {
        switch (key) {
            case "Control":
            case "Shift":
            case "Alt":
                return true;
        }

        return false;
    }

    isInputControl(target: any): boolean {
        switch (target.localName) {
            case "textarea":
            case "input":
                return true;
        }

        return false;
    }

    isDelete(key: string): boolean {
        return key == "Delete";
    }

    isPopupsOpened(): boolean {
        return this.popupsOpenedCount != 0;
    }
}